import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { Nav, Container, Navbar } from "react-bootstrap";
import useScrollToElement from "../../hooks/useScrollToElement";
import { useActiveSection } from "../../hooks/useActiveSection";
import useScrollRestoration from "../../hooks/useScrollRestoration";

function NavBar() {
  useScrollRestoration();
  const scrollToElement = useScrollToElement();

  const [isTransparent, setIsTransparent] = useState(true);

  const sectionIds = ["landing", "stack", "projects", "contact"];

  const activeSection = useActiveSection(sectionIds);

  useEffect(() => {
    const handleScroll = () => {
      if (
        window.scrollY < window.innerHeight * 0.1 &&
        window.location.pathname === "/"
      ) {
        setIsTransparent(true);
      } else {
        setIsTransparent(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <>
      <Container fluid className="px-0 main-content">
        <Navbar
          className={`${!isTransparent ? "nav-colored" : ""} my-nav px-lg-5`}
          collapseOnSelect
          expand="lg"
        >
          <div className="w-100 h-100 d-lg-flex align-items-center justify-content-between">
            <div className="h-100 d-flex justify-content-between align-items-center">
              <div
                role="button"
                onClick={() => scrollToElement("/", "landing")}
                className="ml-sm-nav"
              >
                <Navbar.Brand as={"span"}>
                  {!isTransparent && (
                    <img alt="logo" src="/favicon.png" className="nav-logo" />
                  )}
                </Navbar.Brand>
              </div>

              <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            </div>
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="me-auto"></Nav>
              <Nav>
                <div
                  role="button"
                  onClick={() => scrollToElement("/", "landing")}
                  className={
                    activeSection === "landing" ? "nav-link-active" : "nav-link"
                  }
                >
                  <Nav.Link as={"span"}>Home</Nav.Link>
                </div>

                <div
                  role="button"
                  onClick={() => scrollToElement("/", "stack")}
                  className={
                    activeSection === "stack" ? "nav-link-active" : "nav-link"
                  }
                >
                  <Nav.Link as={"span"}>Stack</Nav.Link>
                </div>

                <div
                  role="button"
                  onClick={() => scrollToElement("/", "projects")}
                  className={
                    activeSection === "projects"
                      ? "nav-link-active"
                      : "nav-link"
                  }
                >
                  <Nav.Link as={"span"}>Projects</Nav.Link>
                </div>

                <div
                  role="button"
                  onClick={() => scrollToElement("/", "contact")}
                  className={
                    activeSection === "contact" ? "nav-link-active" : "nav-link"
                  }
                >
                  <Nav.Link as={"span"}>Contact</Nav.Link>
                </div>
              </Nav>
            </Navbar.Collapse>
          </div>
        </Navbar>
        <Outlet />
      </Container>
    </>
  );
}

export default NavBar;
